import { CancelledError } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { getBalanceQueryOptions } from '#pages/staff/balance/state/balance-query'
import { keycloak } from '#shared/lib/auth'

export const Route = createFileRoute(
  '/staff/_post-registration-required/_confirmation-required/balance',
)({
  loader: async ({ context }) => {
    const { queryClient } = context

    const staffId = keycloak.tokenParsed?.sub
    if (!staffId) throw new Error('Staff not found')

    try {
      queryClient.ensureInfiniteQueryData(getBalanceQueryOptions(staffId))
    } catch (error) {
      if (error instanceof CancelledError) return
      throw error
    }
  },
})
